import { makeStyles } from '@material-ui/core/styles'
//    background: '#DCDCDC',
const StylesWithMaterialUi = makeStyles((theme) => ({
  helperText: {
    fontFamily: 'Poppins',
    width: 300,
  },
  circularProgress: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: theme.spacing(10),
  },
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  gridItem: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  gridItemBtn: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'wrap',
    marginTop: theme.spacing(2),
  },
  text: {
    fontWeight: 'bold',
    fontFamily: 'Comfortaa',
  },
  button: {
    fontSize: '12px',
    fontWeight: '300',
    fontFamily: 'Comfortaa',
    textTransform: 'none',
    width: '110px',
    height: 'auto',
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}))
export default StylesWithMaterialUi
